import { sortByLocation } from './sortByLocation';
import { IValidationResult } from './interfaces';
import { getItemLocation } from './getItemLocation';
import { validateItem } from './items';
import { ICDViewItemGroups } from '../../ui-toolkit/cdItems/interfaces/ICDViewItemCollection';
import { ICDV3ViewItem } from '../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { IOrderDetailsData } from '../../ui-toolkit/orders/interfaces/IOrderDetailsData';

const isNamedSection = (section: string) => section.length > 1;

export const createValidationResult = (
  items: ICDViewItemGroups,
  orderDetails: IOrderDetailsData
): IValidationResult => {
  // Logger.debug('validationResult', { items: this.items.asArray, dirty: this.items.asArray.filter(item => item.dirty).length });
  const itemValidationResults = items.asArray
    .filter((item: ICDV3ViewItem) => item.dirty)
    .map(validateItem(orderDetails));
  const isValid = itemValidationResults.reduce((validity, result) => validity && result.valid, true);
  return {
    id: items.asArray.map((item) => item.id).join('|'),
    message: isValid ? 'OK' : `item${itemValidationResults.length === 1 ? ' is' : 's are'} invalid`,
    valid: isValid,
    items: itemValidationResults
      .map((item) => {
        const location = getItemLocation(item.id, items);
        return {
          ...item,
          location,
          message: `There was a problem ${location && isNamedSection(location.section) ? 'with' : 'on Line'} ${
            location ? location.section + location.line : ''
          }`,
        };
      })
      .sort(sortByLocation),
  };
};
